import api from "../Api";
import { BaseService } from "../BaseService";

const URL = "/system";

export class MaintenanceService extends BaseService {
  async getMaintenance(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get(`${URL}/maintenance`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}